import { TemplateElement, html, defineElement, i18n } from '@webtides/element-js';

import { ComparisonServiceEvents, ComparisonService } from './ComparsionService';

export default class ComparisonAddLink extends TemplateElement {
    properties() {
        return {
            sku: null,
            isInComparsion: false,
        };
    }

    watch() {
        return {
            sku: async () => {
                this.isInComparsion = await ComparisonService.has(this.sku);
            },
        };
    }

    get comparisonEnabled() {
        return window.siteConfig()?.comparisonEnabled ?? false;
    }

    get comparisonLink() {
        return window.siteConfig()?.comparisonLink ?? false;
    }

    events() {
        return {
            '[ref="addBtn"]': {
                click: async e => {
                    e.preventDefault();
                    e.stopPropagation();
                    const response = await ComparisonService.add(this.sku);
                    if (response.error) {
                        const modal = document.querySelector(`[modal-id="comparisonAddError"]`);
                        if (modal) modal.open();
                    }
                },
            },
            '[ref="pageLink"]': {
                click: async e => {
                    // prevent bubbling
                    e.stopPropagation();
                },
            },
            document: {
                [ComparisonServiceEvents.UPDATE]: async () => {
                    this.isInComparsion = await ComparisonService.has(this.sku);
                },
            },
        };
    }

    template() {
        if (!this.comparisonEnabled) {
            return null;
        }
        if (this.isInComparsion) {
            return html` <a href="${this.comparisonLink}" ref="pageLink" class="flex items-center">
                <div class="flex items-center justify-center mr-2">
                    <svg-icon class="inline-block w-4 h-4" name="compare"></svg-icon>
                </div>
                <span class="text-sm md:text-base"> ${i18n('comparison.linkLabel', 'Zum Produktvergleich')} </span>
            </a>`;
        } else {
            return html`
                <button class="flex items-center" ref="addBtn">
                    <div class="flex items-center justify-center mr-2">
                        <svg-icon class="inline-block w-4 h-4" name="compare"></svg-icon>
                    </div>
                    <span class="text-sm md:text-base"> ${i18n('comparison.addBike', 'Produkt vergleichen')} </span>
                </button>
            `;
        }
    }
}

defineElement('comparison-add-link', ComparisonAddLink);
